import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

function RadioEssayDetail() {
  const { id } = useParams();
  const [essay, setEssay] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/essays/${id}/`)
      .then((res) => {
        setEssay(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Essay not found.");
        setLoading(false);
      });
  }, [id]);

  if (loading) return <p className="essay-status">Loading...</p>;
  if (error) return <p className="essay-status">{error}</p>;

  return (
    <article className="essay-detail">
      <header className="essay-detail-header">
        <Link to="/essays" className="back-link" aria-label="Back to essays">
          &larr;
        </Link>
        <h1>{essay.title}</h1>
        <time className="essay-detail-date" dateTime={essay.aired_at}>
          Aired{" "}
          {new Date(essay.aired_at).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </time>
      </header>
      <p className="essay-detail-summary">{essay.summary}</p>
      <div className="essay-detail-body">
        {essay.body.split("\n\n").map((paragraph, i) => (
          <p key={i}>{paragraph}</p>
        ))}
      </div>
    </article>
  );
}

export default RadioEssayDetail;
